import React from "react";

function Blog() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>Blog</h2>
      <p>
        Stay updated on the latest physiotherapy news, exercise tips, and
        wellness advice from our expert team. (You can create separate blog
        posts or list them here.)
      </p>
    </div>
  );
}

export default Blog;
